import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AdminSidebar from '../../components/AdminSidebar';
import AdminTopBar from '../../components/AdminTopBar';
import { API_BASE_URL } from '../../config';

const getAdminHeaders = () => {
  const token = localStorage.getItem('adminToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export default function AdminSurveys() {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => { fetchTemplates(); }, []);

  async function fetchTemplates() {
    setLoading(true);
    try {
      const r = await fetch(`${API_BASE_URL}/api/surveys/templates`, { credentials: 'include', headers: getAdminHeaders() });
      if (!r.ok) throw new Error('failed');
      const j = await r.json();
      setTemplates(j.templates || []);
    } catch (e) {
      console.error(e);
    } finally { setLoading(false); }
  }

  const newUserTemplates = templates.filter(t => t.activeForNewUsers);
  const registrationTemplates = templates.filter(t => (t.key && t.key.toLowerCase().includes('register')) || t.key === 'registration');

  return (
    <div className="flex h-screen w-full bg-slate-50 dark:bg-[#0d141c]">
      <AdminSidebar mobileOpen={mobileSidebarOpen} onCloseMobile={() => setMobileSidebarOpen(false)} />
      <main className="flex-1 flex flex-col h-full overflow-hidden bg-background-light dark:bg-[#0d141c] relative md:ml-[var(--admin-sidebar-width,18rem)] transition-[margin] duration-300">
        <AdminTopBar onToggleMobile={() => setMobileSidebarOpen(open => !open)} />

        <div className="flex-1 overflow-y-auto p-6 lg:p-10">
          <div className="max-w-[1440px] mx-auto w-full">
            <h2 className="text-xl font-bold mb-4 dark:text-white">Anketler — Ana Sayfa</h2>

            <div className="mb-6 bg-white dark:bg-slate-800 p-4 rounded shadow border border-transparent dark:border-slate-700">
              <div className="flex justify-between items-center">
                <h3 className="font-semibold dark:text-white">Yeni Kullanıcı Anketleri</h3>
                <Link to="/admin/surveys/new-user" className="text-sm bg-primary text-white px-3 py-1 rounded">Yeni Kullanıcı Anketi Oluştur / Yönet</Link>
              </div>
              <div className="mt-3">
                {loading ? <div className="dark:text-slate-400">Yükleniyor...</div> : (
                  newUserTemplates.length ? newUserTemplates.map(t => (
                    <div key={t.id} className="border border-gray-100 dark:border-slate-700 rounded p-2 mb-2 flex justify-between items-center dark:bg-slate-900/50">
                      <div>
                        <div className="font-medium dark:text-white">{t.title} <span className="text-xs text-gray-500 dark:text-slate-400">v{t.version}</span></div>
                        <div className="text-xs text-gray-600 dark:text-slate-400">Yayın: {t.publishAt ? new Date(t.publishAt).toLocaleString() : 'Anında'} · Audience: {t.audience}</div>
                      </div>
                      <div>
                        <Link to={`/admin/surveys/new-user?id=${t.id}`} className="text-sm text-primary underline">Yönet</Link>
                      </div>
                    </div>
                  )) : <div className="text-sm text-gray-600 dark:text-slate-400">Yeni kullanıcı anketi yok.</div>
                )}
              </div>
            </div>

            <div className="mb-6 bg-white dark:bg-slate-800 p-4 rounded shadow border border-transparent dark:border-slate-700">
              <div className="flex justify-between items-center">
                <h3 className="font-semibold dark:text-white">Kullanıcı Kayıt Anketleri</h3>
                <Link to="/admin/surveys/registration" className="text-sm bg-primary text-white px-3 py-1 rounded">Kayıt Anketini Yönet</Link>
              </div>
              <div className="mt-3">
                {loading ? <div className="dark:text-slate-400">Yükleniyor...</div> : (
                  registrationTemplates.length ? registrationTemplates.map(t => (
                    <div key={t.id} className="border border-gray-100 dark:border-slate-700 rounded p-2 mb-2 flex justify-between items-center dark:bg-slate-900/50">
                      <div>
                        <div className="font-medium dark:text-white">{t.title} <span className="text-xs text-gray-500 dark:text-slate-400">v{t.version}</span></div>
                        <div className="text-xs text-gray-600 dark:text-slate-400">Audience: {t.audience}</div>
                      </div>
                      <div>
                        <Link to={`/admin/surveys/registration?id=${t.id}`} className="text-sm text-primary underline">Yönet</Link>
                      </div>
                    </div>
                  )) : <div className="text-sm text-gray-600 dark:text-slate-400">Kayıt anketi yok.</div>
                )}
              </div>
            </div>

            <div className="bg-white dark:bg-slate-800 p-4 rounded shadow border border-transparent dark:border-slate-700">
              <h3 className="font-semibold dark:text-white">Diğer Şablonlar</h3>
              <div className="mt-3">
                {loading ? <div className="dark:text-slate-400">Yükleniyor...</div> : (
                  templates.filter(t => !t.activeForNewUsers && !((t.key || '').toLowerCase().includes('register') || t.key === 'registration')).map(t => (
                    <div key={t.id} className="border border-gray-100 dark:border-slate-700 rounded p-2 mb-2 flex justify-between items-center dark:bg-slate-900/50">
                      <div>
                        <div className="font-medium dark:text-white">{t.title} <span className="text-xs text-gray-500 dark:text-slate-400">v{t.version}</span></div>
                        <div className="text-xs text-gray-600 dark:text-slate-400">Audience: {t.audience}</div>
                      </div>
                      <div>
                        <Link to={`/admin/surveys/new-user?id=${t.id}`} className="text-sm text-primary underline">Yönet</Link>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>

          </div>
        </div>
      </main>
    </div>
  );
}
